// THE named z-layer map for the SortableGrid stack — every zIndex inside the
// grid (shell decoration layers, resize handles, the container pill, the
// active tile) comes from here. Scattered literals are how the empty-state
// panel ended up painting over the marquee picker; a new layer must take a
// name and a slot in this ordering, never a raw number.
//
// Ordering notes:
//   - `selection` (the marquee rect + its inline picker) sits ABOVE
//     `annotations` (the consumer overlay slot: insertion gutters, empty
//     state) — the picker must never open under an annotation panel. The
//     annotations wrapper is pointer-inert (`pointerEvents: none`), so the
//     higher selection layer steals nothing from it.
//   - `pill` (the container's hover chrome, protruding above the tile) rides
//     above resting/resizing tiles but below the dragging tile.
export const GRID_LAYER = {
  guides: 0,
  decoration: 1,
  // The columns widget's per-column quick-add band. Shares the decoration
  // slot (they never overlap; DOM order tiebreaks) — the load-bearing fact is
  // it sits BELOW edgeHandle: the band is bottom-aligned in the column's last
  // row, exactly over the last child's s-resize strip, and the handle must
  // win that hover overlap or the child becomes unresizable.
  columnFooter: 1,
  edgeHandle: 2,
  cornerHandle: 3,
  annotations: 4,
  selection: 5,
  resizingTile: 6,
  pill: 7,
  draggingTile: 10,
} as const;
